import { render } from "./ContratacoesNegadoCanceladoView.vue?vue&type=template&id=272f3510&scoped=true"
import script from "./ContratacoesNegadoCanceladoView.vue?vue&type=script&lang=js"
export * from "./ContratacoesNegadoCanceladoView.vue?vue&type=script&lang=js"

import "./ContratacoesNegadoCanceladoView.vue?vue&type=style&index=0&id=272f3510&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272f3510"]])

export default __exports__